// extracted by mini-css-extract-plugin
export default {"chartContainer":"C3Chart__chartContainer___kadtX"};